// extracted by mini-css-extract-plugin
module.exports = {"flair":"Cursor_flair__ZwXV7","cursor":"Cursor_cursor__BG5YK"};